module.exports = __webpack_public_path__ + "img/artist.02091722.svg";